// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"472":"41c4e044","776":"377b7762"}[chunkId] + ".chunk.js");